<template>
  <v-layout fill-height column class="text-center">
    <v-layout fill-height column align-center justify-center>
      <v-container class="text-center">
        <div class="mb-4"><img :src="getImage('ic_check.svg')"></div>
        <div class="fs-24 fw-700 mb-1">미션을 완료하였습니다.</div>
        <div class="fs-16 gray--text">다른 미션도 완료해보세요.</div>
      </v-container>
    </v-layout>
    <v-container>
      <div class="pos-relative mb-6">
        <div class="pos-relative d-inline fs-14 white px-2 z-1 ">이것에 도움이 돼요!</div>
        <v-divider class="pos-absolute fill-width divider mt-n3"></v-divider>
      </div>
      <div class="d-flex justify-space-around">
        <!-- <img :src="getImage('ic_condition_01.svg')" class="mx-2">
        <img :src="getImage('ic_condition_02.svg')" class="mx-2">
        <img :src="getImage('ic_condition_03.svg')" class="mx-2">
        <img :src="getImage('ic_condition_04.svg')" class="mx-2">
        <img :src="getImage('ic_condition_05.svg')" class="mx-2"> -->
        <div v-for="(n, index) in helpful" :key="n">
          <img :src="getImage(helpfulImg[index])" class="mx-2"><br />
          <b>{{ helpfulText[Number(n) - 1] }}</b>
        </div>
      </div>
    </v-container>
    <div class="footer-btns vertical">
      <!-- <div><img :src="getImage('ic_square_tip.svg')" class="ml-24"></div> -->
      <v-btn v-if="!preview"
             color="primary" class="btn-submit"
             x-large depressed
             @click="submit">광장에 남기기</v-btn>
      <v-btn color="primary" class="btn-reset"
             x-large depressed
             @click="confirm">확인</v-btn>
    </div>
  </v-layout>
</template>
<script>

import {mixinRemote} from "@/mixins";
import store from '../../store'

export default {
  mixins: [
    mixinRemote
  ],
  data: () => ({
    // cmpltYn:'',
    unitUseNo: null,
    helpful: [],
    helpfulImg: [],
    helpfulText: ['자아강도', '인식/표현', '대인관계', '자기조절', '지지자원'],
    contentCnt:0,
    preview:false,
    freeYn: null,
    unitId: null
  }),
  components: {},
  created() {
    // this.cmpltYn = this.$route.params.cmpltYn
    this.unitUseNo = this.$route.params.unitUseNo
    this.helpful = this.$route.params.helpful
    this.freeYn = this.$route.params.freeYn
    this.unitId = this.$route.params.unitId
    this.contentCnt = this.$route.params.contentCnt
    this.preview = this.$route.params.preview


    if ((this.unitUseNo === null || this.unitUseNo === undefined)
        || (this.unitId === null || this.unitId === undefined)
        || (this.freeYn === null || this.freeYn === undefined)) {
      this.$router.go(-1)
      return false
    }

    this.helpful.forEach((element) => {
      // this.helpfulImg.[index] = 'ic_condition_'+ element +'.svg'
      this.helpfulImg.push('ic_condition_' + element + '.svg')
    })
  },
  methods: {
    async submit() {
      await store.dispatch('getSquareRegistPossible', this.$_payload({'gb': '01'}))
          .then(res => {
          if (res.success) {
            if(res.data != null){ // 징계중 작성불가
              this.$alert("회원님은 게시글 징계중("+ res.data.pnshStartDt+" ~ "+ res.data.pnshEndDt +")으로 광장 남기기가 어려워요.")
            }else{  // 작성가능
              this.$router.replace({name: '광장에 남가기', params: {'unitUseNo': this.unitUseNo, 'freeYn': this.freeYn, 'unitId': this.unitId}})
            }

          } else {
            this.$alert("작성 가능여부 조회에 실패하였습니다.")
          }
        }).catch(error => {
          console.error(error)
        }).finally(() => {})
    },
    confirm() {
      this.solutionComplete = true
      if(this.preview){ // 관리자 미리보기
        window.close();
      }else if(this.contentCnt > 0){
        this.$router.go(-this.contentCnt)
      }else{
        this.$router.go(-1)
      }
    }
  },
}
</script>
<style lang="scss" scoped>
//.complete {
//  padding-bottom: 180px;
//}
</style>
